import React, { memo } from 'react';
import styled from 'styled-components';
import ProgressBar from './ProgressBar';
import { formatProgressCount } from '../utils/utils';
import type { ReceptionScanEvent } from '../types/types';

type ScanProgressBoardProps = {
	event: ReceptionScanEvent;
	progressRate: number;
};

// 스캔 모드 실시간 진행 현황 보드
const ScanProgressBoard = memo<ScanProgressBoardProps>(({ event, progressRate }) => {
	return (
		<Wrapper>
			<Head>
				실시간 진행 현황 <UpdatedAt>({event.updatedAt})</UpdatedAt>
			</Head>
			<Body>
				<StatGroup>
					<Stat>
						<StatLabel>전체 참가자</StatLabel>
						<StatValue>{event.totalParticipants.toLocaleString()}</StatValue>
					</Stat>
					<Stat>
						<StatLabel>체크인 완료</StatLabel>
						<StatValue>{event.checkedInCount.toLocaleString()}</StatValue>
					</Stat>
					<Stat>
						<StatLabel>미수령</StatLabel>
						<StatValue>{event.notReceivedCount.toLocaleString()}</StatValue>
					</Stat>
				</StatGroup>
				<ProgressArea>
					<ProgressTop>
						<RateText>{progressRate}%</RateText>
						<CountText>{formatProgressCount(event.checkedInCount, event.totalParticipants)}</CountText>
					</ProgressTop>
					<ProgressBar rate={progressRate} />
				</ProgressArea>
			</Body>
		</Wrapper>
	);
});

ScanProgressBoard.displayName = 'ScanProgressBoard';

export default ScanProgressBoard;

const Wrapper = styled.div`
	padding-bottom: 28px;
`;
const Head = styled.div`
	font-size: 16px;
	font-family: PretendardSemiBold, AppleSDGothicNeoSemiBold, sans-serif;
	margin-bottom: 20px;
`;
const UpdatedAt = styled.span`
	font-size: 13px;
	font-family: PretendardRegular, AppleSDGothicNeoRegular, sans-serif;
	color: ${({ theme }) => theme.colors.lightGrayFontColor};
	margin-left: 6px;
`;
const Body = styled.div`
	display: flex;
	align-items: center;
	gap: 40px;
`;
const StatGroup = styled.div`
	display: flex;
	gap: 60px;
`;
const Stat = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
`;
const StatLabel = styled.div`
	font-size: 14px;
	color: ${({ theme }) => theme.colors.deepGrayFontColor};
`;
const StatValue = styled.div`
	font-size: 26px;
	font-family: PretendardSemiBold, AppleSDGothicNeoSemiBold, sans-serif;
`;
const ProgressArea = styled.div`
	flex: 1;
	min-width: 0;
`;
const ProgressTop = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 10px;
`;
const RateText = styled.div`
	font-size: 14px;
	font-family: PretendardSemiBold, AppleSDGothicNeoSemiBold, sans-serif;
`;
const CountText = styled.div`
	font-size: 14px;
	color: ${({ theme }) => theme.colors.lightGrayFontColor};
`;
